import classNames from "classnames";
import React from "react";
import CloseIcon from "@/components/ui/OpticksIcons/CloseIcon";
import OpticksButton from "../OpticksButton/OpticksButton";
import "./OpticksInput.css";
import SearchIcon from "../OpticksIcons/SearchIcon";

export interface Props {
  autoFocus?: boolean;
  surface?: "default" | "white";
  className?: string;
  disabled?: boolean;
  input?: React.ComponentPropsWithoutRef<"input">;
  isInvalid?: boolean;
  preventEnter?: boolean;
  size?: "max" | "m";
  placeholder?: string;
  readOnly?: boolean;
  required?: boolean;
  type?: "text" | "email" | "password" | "url";
  withCloseIcon?: boolean;
  withSearchIcon?: boolean;
}

const OpticksInput = ({
  type = "text",
  autoFocus = false,
  withCloseIcon = false,
  withSearchIcon = false,
  placeholder = "",
  isInvalid = false,
  disabled = false,
  className = "",
  input,
  required = false,
  readOnly = false,
  surface,
  preventEnter = false,
  size = "max", // "max" = "100%", "m" = "160px"
}: Props) => {
  const fallbackId = React.useId();
  const inputId = input?.id || fallbackId;

  return (
    <div
      className={classNames(
        "opticks-input",
        className,
        { [`size-${size}`]: size },
        { [`surface-${surface}`]: surface },
        { "is-invalid": isInvalid }
      )}
    >
      {withSearchIcon && <SearchIcon className="icon-medium-grey" />}
      <input
        id={inputId}
        type={type}
        aria-invalid={isInvalid || undefined}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
        autoFocus={autoFocus}
        onKeyDown={(e) => {
          preventEnter && e.key === "Enter" && e.preventDefault();
        }}
        {...input}
      />
      {withCloseIcon && input?.value && !disabled && !readOnly && (
        <OpticksButton
          aria-label="Clear"
          icon={<CloseIcon className="icon-dark-blue" />}
          onClick={() => {
            if (!input?.onChange) return;

            const fakeEvent = {
              target: { value: "" },
            } as React.ChangeEvent<HTMLInputElement>;

            input.onChange(fakeEvent);
          }}
        />
      )}
    </div>
  );
};

export default OpticksInput;
